import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, watch } from "vue"
import store from "@/vue/planning/store/store"

// components
import Form from "@/vue/planning/components/search/form.vue";
import Banners from "@/vue/planning/components/common/banners.vue";
import Packages from "@/vue/planning/components/search/packages.vue";

// config

// computed
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"
import screenType from "@/vue/planning/computed/screenType"
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"

// computed

export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

const stepNum: ComputedRef<string> = computed(()=>{
    if (availableTransportPackCodes.value.length > 0 && store.state.screenType === "desktop") return "2. "
    return "1. "
})

watch(
    () => store.getters.variants,
    () => store.dispatch("ensurePrestationsPreselected")
)


return { __sfc: true,stepNum, store, Form, Banners, Packages, screenType, packagesToDisplay }
}

})